export enum WindowsServiceStartType {
    Automatic = 'Automatic',
    Manual = 'Manual',
    Disabled = 'Disabled',
}
